// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.GetFeaturePermissionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetFeaturePermissionsRequestDto, GetFeaturePermissionsWebApiResponseDto } from '../..';

export const GetFeaturePermissionsWebApiHandler_getFeaturePermissions_Path =
  '/api/web/v1/landlord/getFeaturePermissions';

/**
 * get landlord feature permissions
 */
export const GetFeaturePermissionsWebApiHandler_getFeaturePermissions = (
  postData: GetFeaturePermissionsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetFeaturePermissionsRequestDto, GetFeaturePermissionsWebApiResponseDto>(
    {
      endpoint: GetFeaturePermissionsWebApiHandler_getFeaturePermissions_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
